import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CONTENT } from "./content";
import { useSite } from "../context/SiteContext";

const LangContext = createContext(null);

const isGfx = (k) => k === "icon" || k === "image" || k.endsWith("_image");
const shareGraphics = (hi, en) => {
  if (Array.isArray(hi) && Array.isArray(en)) return hi.map((x, i) => shareGraphics(x, en[i]));
  if (hi && en && typeof hi === "object" && typeof en === "object" && !Array.isArray(hi)) {
    return Object.fromEntries(Object.entries(hi).map(([k, v]) => [k, isGfx(k) && typeof en[k] === "string" && en[k] ? en[k] : shareGraphics(v, en[k])]));
  }
  return hi;
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("da247-lang") || "en");
  const remote = useSite().site?.content;
  const t = useMemo(() => {
    const base = remote?.[lang] ? { ...CONTENT[lang], ...remote[lang] } : CONTENT[lang];
    return lang === "hi" && remote?.en ? shareGraphics(base, remote.en) : base;
  }, [remote, lang]);

  useEffect(() => {
    localStorage.setItem("da247-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang(lang === "en" ? "hi" : "en");
  return <LangContext.Provider value={{ lang, t, toggle }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangToggle = ({ testid = "lang-toggle" }) => {
  const { lang, toggle } = useLang();
  return (
    <button onClick={toggle} data-testid={testid} aria-label="Switch language"
      className="flex h-9 items-center rounded-full border border-[#D4AF37]/40 p-0.5 text-xs font-semibold">
      {["en", "hi"].map((l) => (
        <span key={l} className={`rounded-full px-2 py-1.5 transition-colors sm:px-2.5 ${lang === l ? "bg-[#D4AF37] text-black" : "text-[#D4AF37]"}`}>
          {l === "en" ? "EN" : "हिं"}
        </span>
      ))}
    </button>
  );
};
